import { isOfflineWriteBlockedError } from "common/utils/offlineWriteGuard";

/** True when a failed request likely means no usable network (not a server/business error). */
export function isNetworkRequestError(error: unknown): boolean {
  if (isOfflineWriteBlockedError(error)) return true;
  if (error instanceof DOMException && error.name === "AbortError") return true;
  if (error instanceof TypeError) {
    const msg = error.message.toLowerCase();
    return (
      msg.includes("failed to fetch") ||
      msg.includes("networkerror") ||
      msg.includes("network request failed") ||
      msg.includes("load failed") ||
      msg.includes("aborted")
    );
  }
  return false;
}
